import React, { useCallback, useRef, useState } from 'react';
import { CheckIcon, ChevronDownIcon, LayersIcon } from 'lucide-react';
import { ALL_PAGE_CAP } from '../../hooks/useRegistrationsTable';
import { Popover } from '../ui/Popover';

const options = [
  { value: 'none', label: 'No grouping', short: 'None' },
  { value: 'program', label: 'Program', short: 'Program' },
  { value: 'stay', label: 'Commuter / Overnight', short: 'Stay' },
  { value: 'status', label: 'Status', short: 'Status' },
];

export function GroupByMenu({ value, onChange }) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const current = options.find(o => o.value === value) ?? options[0];
  const active = value !== 'none';

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="dialog"
        aria-expanded={open}
        className={`tw-inline-flex tw-h-9 tw-shrink-0 tw-items-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-border tw-px-3 tw-text-sm tw-font-medium tw-transition-colors tw-duration-150 ${
          active ? 'tw-border-brand-200 tw-bg-brand-50 tw-text-brand-600' : 'tw-border-neutral-200 tw-bg-white tw-text-neutral-900 hover:tw-bg-sand-50'
        }`}>
        <LayersIcon className={`tw-h-4 tw-w-4 ${active ? '' : 'tw-text-neutral-500'}`} aria-hidden />
        Group: {current.short}
        <ChevronDownIcon className="tw-h-4 tw-w-4 tw-opacity-70" aria-hidden />
      </button>
      <Popover anchorRef={anchorRef} open={open} onClose={close} align="end" label="Group rows" width={220}>
        <div role="radiogroup" aria-label="Group rows by" className="tw-p-1.5">
          {options.map(o => (
            <button
              key={o.value}
              type="button"
              role="radio"
              aria-checked={o.value === value}
              onClick={() => {
                onChange(o.value);
                close();
              }}
              className="tw-flex tw-w-full tw-items-center tw-gap-2.5 tw-rounded-md tw-px-2.5 tw-py-1.5 tw-text-left tw-text-sm tw-transition-colors tw-duration-100 hover:tw-bg-sand-50">
              <CheckIcon className={`tw-h-4 tw-w-4 tw-text-brand-600 ${o.value === value ? '' : 'tw-invisible'}`} aria-hidden />
              {o.label}
            </button>
          ))}
        </div>
        <p className="tw-border-t tw-border-neutral-200 tw-px-3 tw-py-2 tw-text-xs tw-text-neutral-400">
          Grouped views show subtotals per group, {ALL_PAGE_CAP} rows per page.
        </p>
      </Popover>
    </>
  );
}
